
  import createMeisterIcons from '../src/createMeisterIcons';

  const Cross = createMeisterIcons("cross", [["path",{"fill":"currentColor","d":"M18.18 5.82a.75.75 0 0 1 0 1.06l-11.3 11.3a.75.75 0 1 1-1.06-1.06l11.3-11.3a.75.75 0 0 1 1.06 0","key":"23787f488d00486b6d8b4650caaf5d08e410eb21","fillRule":"evenodd","clipRule":"evenodd"}],["path",{"fill":"currentColor","d":"M5.82 5.82a.75.75 0 0 1 1.06 0l11.3 11.3a.75.75 0 0 1-1.06 1.06L5.82 6.88a.75.75 0 0 1 0-1.06","key":"4c873b25cb3cd0708788a5926d5fe623769c4b22","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default Cross
  